import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { LayoutDashboard, BookOpen, Award, Download, FileText } from "lucide-react";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";

export const Route = createFileRoute("/_authenticated/student")({
  head: () => ({ meta: [{ title: "Student Portal — Code Cubs" }] }),
  component: StudentLayout,
});

const navItems = [
  { to: "/student", label: "الرئيسية", icon: LayoutDashboard, exact: true },
  { to: "/student/assignments", label: "واجباتي", icon: FileText },
  { to: "/student/quizzes", label: "اختباراتي", icon: BookOpen },
  { to: "/student/badges", label: "شاراتي", icon: Award },
  { to: "/student/certificates", label: "شهاداتي", icon: Award },
  { to: "/student/resources", label: "المصادر", icon: Download },
];

function StudentLayout() {
  return (
    <RoleGuard allowedRoles={["student", "admin"]}>
      <DashboardLayout title="لوحة الطالب" navItems={navItems}>
        <Outlet />
      </DashboardLayout>
    </RoleGuard>
  );
}
